import React, { useEffect } from "react";

export default function About() {
  useEffect(() => {
    document.title = "About | Development Solutions";
  }, []);

  return (
    <>
      {/* HERO SECTION */}
      <section
        className="relative h-[50vh] flex items-center justify-center text-center"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1600')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 max-w-3xl px-4 sm:px-6">
          <h1
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight"
            style={{ fontFamily: "Montserrat, sans-serif" }}
          >
            About Dev Sols
          </h1>
          <p
            className="mt-4 text-sm sm:text-base lg:text-lg text-gray-200 max-w-2xl mx-auto"
            style={{ fontFamily: "Montserrat, sans-serif" }}
          >
            We are a forward-thinking software company, empowering businesses
            with scalable and innovative digital solutions.
          </p>
        </div>
      </section>

      {/* WHO WE ARE */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto h-[40vh] text-center flex flex-col justify-center px-4 sm:px-6 gap-6 sm:gap-12">
          <div>
            <h2
              className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6"
              style={{ color: "#414042", fontFamily: "Montserrat, sans-serif" }}
            >
              Who We <span style={{ color: "#1b75bc" }}>Are</span>
            </h2>
            <p
              className="text-sm sm:text-base lg:text-lg leading-relaxed mb-3 sm:mb-4"
              style={{
                color: "#414042",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 500,
              }}
            >
              Dev Sols is a trusted technology partner for startups,
              enterprises, and global businesses. We specialize in creating
              seamless digital experiences through web & mobile development,
              digital marketing, and technical consulting.
            </p>
            <p
              className="text-sm sm:text-base lg:text-lg leading-relaxed"
              style={{
                color: "#414042",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 500,
              }}
            >
              With a dedicated team of developers, designers, and consultants,
              we combine innovation with technical excellence to help businesses
              scale efficiently.
            </p>
          </div>
        </div>
      </section>

      {/* MISSION & VISION */}
      <section className="bg-gray-50">
        <div className="max-w-7xl flex flex-col justify-center h-[90vh] mx-auto px-4 sm:px-6 text-center">
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-8 sm:mb-12"
            style={{ color: "#414042", fontFamily: "Montserrat, sans-serif" }}
          >
            Our Mission & <span style={{ color: "#1b75bc" }}>Vision</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 lg:gap-10">
            <div className="bg-white rounded-lg shadow p-4 sm:p-6 lg:p-8 hover:shadow-lg transition">
              <img
                src="https://images.pexels.com/photos/3184460/pexels-photo-3184460.jpeg?auto=compress&cs=tinysrgb&w=800"
                alt="Mission"
                className="w-full h-40 sm:h-48 object-cover rounded-md mb-4 sm:mb-6"
              />
              <h3
                className="text-lg sm:text-xl lg:text-2xl font-bold mb-3 sm:mb-4"
                style={{
                  color: "#1b75bc",
                  fontFamily: "Montserrat, sans-serif",
                }}
              >
                Our Mission
              </h3>
              <p
                className="text-sm sm:text-base lg:text-lg"
                style={{
                  color: "#414042",
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 500,
                }}
              >
                To empower businesses with cutting-edge technology solutions
                that drive innovation, growth, and long-term success.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow p-4 sm:p-6 lg:p-8 hover:shadow-lg transition">
              <img
                src="https://images.pexels.com/photos/3184306/pexels-photo-3184306.jpeg?auto=compress&cs=tinysrgb&w=800"
                alt="Vision"
                className="w-full h-40 sm:h-48 object-cover rounded-md mb-4 sm:mb-6"
              />
              <h3
                className="text-lg sm:text-xl lg:text-2xl font-bold mb-3 sm:mb-4"
                style={{
                  color: "#1b75bc",
                  fontFamily: "Montserrat, sans-serif",
                }}
              >
                Our Vision
              </h3>
              <p
                className="text-sm sm:text-base lg:text-lg"
                style={{
                  color: "#414042",
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 500,
                }}
              >
                To become a global leader in digital transformation, delivering
                solutions that shape the future of businesses worldwide.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CORE VALUES */}
      <section className="bg-white">
        <div className="max-w-7xl flex flex-col justify-center h-[90vh] mx-auto px-4 sm:px-6 text-center">
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-8 sm:mb-12"
            style={{ color: "#414042", fontFamily: "Montserrat, sans-serif" }}
          >
            Our Core <span style={{ color: "#1b75bc" }}>Values</span>
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            {[
              {
                title: "Innovation",
                desc: "We embrace creativity and cutting-edge technologies.",
                img: "https://images.pexels.com/photos/3184639/pexels-photo-3184639.jpeg?auto=compress&cs=tinysrgb&w=800",
              },
              {
                title: "Transparency",
                desc: "Open communication & honesty in every project we deliver.",
                img: "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=800",
              },
              {
                title: "Excellence",
                desc: "We strive for the highest quality in all our solutions.",
                img: "https://images.pexels.com/photos/3184302/pexels-photo-3184302.jpeg?auto=compress&cs=tinysrgb&w=800",
              },
              {
                title: "Customer First",
                desc: "Your success is our priority and our driving force.",
                img: "https://images.pexels.com/photos/3184419/pexels-photo-3184419.jpeg?auto=compress&cs=tinysrgb&w=800",
              },
            ].map((value, idx) => (
              <div
                key={idx}
                className="bg-gray-50 rounded-lg shadow hover:shadow-lg transition overflow-hidden"
              >
                <img
                  src={value.img}
                  alt={value.title}
                  className="h-32 sm:h-40 w-full object-cover"
                />
                <div className="p-4 sm:p-6">
                  <h3
                    className="text-base sm:text-lg lg:text-xl font-bold mb-2"
                    style={{
                      color: "#1b75bc",
                      fontFamily: "Montserrat, sans-serif",
                    }}
                  >
                    {value.title}
                  </h3>
                  <p
                    className="text-xs sm:text-sm lg:text-base"
                    style={{
                      color: "#414042",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: 500,
                    }}
                  >
                    {value.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CEO MESSAGE SECTION */}
      <section className="bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-[90vh] flex flex-col lg:grid lg:grid-cols-2 gap-8 lg:gap-16 items-center justify-center">
          {/* BIGGER CEO IMAGE */}
          <div className="flex justify-center order-2 lg:order-1">
            <img
              src="/own-new.jpg"
              alt="CEO"
              className="rounded-xl shadow-2xl w-full max-w-xs sm:max-w-sm md:max-w-md h-auto lg:h-[70vh] object-cover object-top"
            />
          </div>

          {/* CEO MESSAGE */}
          <div className="order-1 lg:order-2 text-center lg:text-left">
            <h2
              className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6"
              style={{ color: "#414042", fontFamily: "Montserrat, sans-serif" }}
            >
              A Message from Our <span style={{ color: "#1b75bc" }}>CEO</span>
            </h2>
            <p
              className="text-base sm:text-lg lg:text-xl leading-relaxed italic mb-4 sm:mb-6"
              style={{
                color: "#414042",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 500,
              }}
            >
              "At Dev Sols, we believe technology is more than just code. It's
              about creating meaningful digital experiences that transform
              businesses and improve lives. Our team is committed to excellence,
              innovation, and building long-lasting partnerships with our
              clients."
            </p>
            <h4
              className="text-lg sm:text-xl lg:text-2xl font-bold"
              style={{ color: "#1b75bc", fontFamily: "Montserrat, sans-serif" }}
            >
              Omar Arshad
            </h4>
            <p
              className="text-sm sm:text-base lg:text-lg"
              style={{
                color: "#414042",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 500,
              }}
            >
              CEO & Founder, Dev Sols
            </p>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 bg-white text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold"
            style={{ color: "#414042", fontFamily: "Montserrat, sans-serif" }}
          >
            Want to Work With Us?
          </h2>
          <p
            className="mt-4 text-sm sm:text-base lg:text-lg max-w-2xl mx-auto"
            style={{
              color: "#414042",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 500,
            }}
          >
            We're always ready to collaborate with ambitious businesses and
            bring their digital ideas to life.
          </p>
          <a
            href="/contact"
            className="mt-6 inline-block px-6 sm:px-8 py-3 sm:py-4 rounded-md text-white font-bold"
            style={{ backgroundColor: "#1b75bc" }}
          >
            Get in Touch
          </a>
        </div>
      </section>
    </>
  );
}
